import React, { useContext } from 'react';
import Account from './account';
import styles from './style.module.css';
import Context from '../../utils/context';
import DeactivateAccount from './deactivate_account';
import { isFeatureEnabled, FEATURES } from '../../helpers/feature_checker';
import NewSettings, { NewProfileEdit } from './new_settings';

export default function Settings() {
  const context = useContext(Context);
  const currentAccount = context.auth.currentAccount();
  const isNewUiEnabled = isFeatureEnabled(currentAccount, FEATURES.NEW_UI);

  if (isNewUiEnabled) {
    return <NewSettings />;
  }

  const isSuperUser = context.auth.isSuperUser();
  const isMobile = context.viewport.getIsMobile();

  return (
    <div className={`${styles.settings} container`}>
      <div className={`row justify-content-center`}>
        <div className={`col-md-8 col`}>
          <div className={styles.mobile_account}>
            <Account isMobile={isMobile} />
          </div>
          {!isSuperUser && (
            <div>
              <DeactivateAccount />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function ProfileEditSettings() {
  const context = useContext(Context);
  const currentAccount = context.auth.currentAccount();
  const isNewUiEnabled = isFeatureEnabled(currentAccount, FEATURES.NEW_UI);

  if (isNewUiEnabled) {
    return <NewProfileEdit />;
  }

  return <Settings />;
}
